import { render } from "./EditContactList.vue?vue&type=template&id=27fecdce&scoped=true"
import script from "./EditContactList.vue?vue&type=script&lang=ts"
export * from "./EditContactList.vue?vue&type=script&lang=ts"

import "./EditContactList.vue?vue&type=style&index=0&id=27fecdce&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-27fecdce"

export default script